import _objectWithoutProperties from "/vercel/path0/storefront/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/vercel/path0/storefront/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/storefront/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/storefront/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/storefront/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/storefront/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/storefront/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/storefront/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/vercel/path0/storefront/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
var _excluded = ["data"];
import _regeneratorRuntime from "/vercel/path0/storefront/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var d = /*#__PURE__*/function (_Error) {
    _inherits(d, _Error);
    var _super = _createSuper(d);
    function d() {
      _classCallCheck(this, d);
      return _super.call(this);
    }
    _createClass(d, null, [{
      key: "factory",
      value: function factory(s) {
        switch (s) {
          case c.INVALID_REQUEST:
            return new g();
          case c.AUTHENTICATION:
            return new A();
          case c.API:
            return new f();
          case c.PERMISSION:
            return new y();
          case c.CONNECTION:
            return new q();
        }
      }
    }]);
    return d;
  }( /*#__PURE__*/_wrapNativeSuper(Error)),
  c = function (n) {
    return n[n.INVALID_REQUEST = 0] = "INVALID_REQUEST", n[n.API = 1] = "API", n[n.AUTHENTICATION = 2] = "AUTHENTICATION", n[n.PERMISSION = 3] = "PERMISSION", n[n.CONNECTION = 4] = "CONNECTION", n;
  }(c || {}),
  g = /*#__PURE__*/function (_d) {
    _inherits(g, _d);
    var _super2 = _createSuper(g);
    function g() {
      _classCallCheck(this, g);
      return _super2.apply(this, arguments);
    }
    return _createClass(g);
  }(d),
  f = /*#__PURE__*/function (_d2) {
    _inherits(f, _d2);
    var _super3 = _createSuper(f);
    function f() {
      _classCallCheck(this, f);
      return _super3.apply(this, arguments);
    }
    return _createClass(f);
  }(d),
  A = /*#__PURE__*/function (_d3) {
    _inherits(A, _d3);
    var _super4 = _createSuper(A);
    function A() {
      _classCallCheck(this, A);
      return _super4.apply(this, arguments);
    }
    return _createClass(A);
  }(d),
  y = /*#__PURE__*/function (_d4) {
    _inherits(y, _d4);
    var _super5 = _createSuper(y);
    function y() {
      _classCallCheck(this, y);
      return _super5.apply(this, arguments);
    }
    return _createClass(y);
  }(d),
  q = /*#__PURE__*/function (_d5) {
    _inherits(q, _d5);
    var _super6 = _createSuper(q);
    function q() {
      _classCallCheck(this, q);
      return _super6.apply(this, arguments);
    }
    return _createClass(q);
  }(d);
var S = /*#__PURE__*/function () {
    function S() {
      _classCallCheck(this, S);
      this.publishableApiKey = null;
    }
    _createClass(S, [{
      key: "registerPublishableApiKey",
      value: function registerPublishableApiKey(s) {
        this.publishableApiKey = s;
      }
    }, {
      key: "getPublishableApiKey",
      value: function getPublishableApiKey() {
        return this.publishableApiKey;
      }
    }]);
    return S;
  }(),
  p = new S();
import Ks from "axios";
import * as P from "retry-axios";
import { v4 as Ns } from "uuid";
var Vs = {
    "/admin/auth": "POST",
    "/admin/users/password-token": "POST",
    "/admin/users/reset-password": "POST",
    "/admin/invites/accept": "POST"
  },
  Qe = {
    maxRetries: 0,
    baseUrl: "http://localhost:9000"
  },
  C = /*#__PURE__*/function () {
    function C(s) {
      _classCallCheck(this, C);
      this.axiosClient = this.createClient(_objectSpread(_objectSpread({}, Qe), s)), this.config = _objectSpread(_objectSpread({}, Qe), s);
    }
    _createClass(C, [{
      key: "shouldRetryCondition",
      value: function shouldRetryCondition(s, e, t) {
        return e >= t ? !1 : !s.response || s.response.status === 409 || s.response.status > 500 && s.response.status <= 599;
      }
    }, {
      key: "normalizeHeaders",
      value: function normalizeHeaders(s) {
        var _this = this;
        return s && typeof s == "object" ? Object.keys(s).reduce(function (e, t) {
          return e[_this.normalizeHeader(t)] = s[t], e;
        }, {}) : s;
      }
    }, {
      key: "normalizeHeader",
      value: function normalizeHeader(s) {
        return s.split("-").map(function (e) {
          return e.charAt(0).toUpperCase() + e.substr(1).toLowerCase();
        }).join("-");
      }
    }, {
      key: "requiresAuthentication",
      value: function requiresAuthentication(s, e) {
        return s.startsWith("/admin") && Vs[s] !== e;
      }
    }, {
      key: "setHeaders",
      value: function setHeaders(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = {
          Accept: "application/json",
          "Content-Type": "application/json"
        };
        this.config.apiKey && this.requiresAuthentication(t, e) && (n = _objectSpread(_objectSpread({}, n), {}, {
          Authorization: "Bearer ".concat(this.config.apiKey)
        }));
        var a = this.config.publishableApiKey || p.getPublishableApiKey();
        return a && (n["x-publishable-api-key"] = a), this.config.maxRetries > 0 && e === "POST" && (n["Idempotency-Key"] = Ns()), Object.assign({}, n, this.normalizeHeaders(s), r);
      }
    }, {
      key: "createClient",
      value: function createClient(s) {
        var _this2 = this;
        var e = Ks.create({
          baseURL: s.baseUrl
        });
        return P.attach(e), e.defaults.raxConfig = {
          instance: e,
          retry: s.maxRetries,
          backoffType: "exponential",
          shouldRetry: function shouldRetry(t) {
            var _r$currentRetryAttemp, _r$retry;
            var r = P.getConfig(t);
            return r ? _this2.shouldRetryCondition(t, (_r$currentRetryAttemp = r.currentRetryAttempt) !== null && _r$currentRetryAttemp !== void 0 ? _r$currentRetryAttemp : 1, (_r$retry = r.retry) !== null && _r$retry !== void 0 ? _r$retry : 3) : !1;
          }
        }, e;
      }
    }, {
      key: "request",
      value: function () {
        var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(s, e) {
          var t,
            r,
            n,
            a,
            _yield$this$axiosClie,
            u,
            Us,
            _args = arguments;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  t = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                  r = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
                  n = _args.length > 4 && _args[4] !== undefined ? _args[4] : {};
                  a = {
                    method: s,
                    withCredentials: !0,
                    url: e,
                    json: !0,
                    headers: this.setHeaders(r, s, e, n)
                  };
                  ["POST", "DELETE"].includes(s) && (a.data = t);
                  _context.next = 7;
                  return this.axiosClient(a);
                case 7:
                  _yield$this$axiosClie = _context.sent;
                  u = _yield$this$axiosClie.data;
                  Us = _objectWithoutProperties(_yield$this$axiosClie, _excluded);
                  return _context.abrupt("return", _objectSpread(_objectSpread({}, u), {}, {
                    response: Us
                  }));
                case 11:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
        function request(_x, _x2) {
          return _request.apply(this, arguments);
        }
        return request;
      }()
    }]);
    return C;
  }(),
  T = C;
var i = /*#__PURE__*/_createClass(function i(s) {
  _classCallCheck(this, i);
  this.client = s;
});
var O = /*#__PURE__*/function (_i) {
    _inherits(O, _i);
    var _super7 = _createSuper(O);
    function O() {
      _classCallCheck(this, O);
      return _super7.apply(this, arguments);
    }
    _createClass(O, [{
      key: "addAddress",
      value: function addAddress(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/customers/me/addresses";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "deleteAddress",
      value: function deleteAddress(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/customers/me/addresses/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "updateAddress",
      value: function updateAddress(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/customers/me/addresses/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }]);
    return O;
  }(i),
  $ = O;
var E = /*#__PURE__*/function (_i2) {
    _inherits(E, _i2);
    var _super8 = _createSuper(E);
    function E() {
      _classCallCheck(this, E);
      return _super8.apply(this, arguments);
    }
    _createClass(E, [{
      key: "authenticate",
      value: function authenticate(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/auth";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "deleteSession",
      value: function deleteSession() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/store/auth";
        return this.client.request("DELETE", e, {}, {}, s);
      }
    }, {
      key: "getSession",
      value: function getSession() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/store/auth";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }, {
      key: "exists",
      value: function exists(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/auth/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return E;
  }(i),
  x = E;
var G = /*#__PURE__*/function (_i3) {
    _inherits(G, _i3);
    var _super9 = _createSuper(G);
    function G() {
      _classCallCheck(this, G);
      return _super9.apply(this, arguments);
    }
    _createClass(G, [{
      key: "create",
      value: function create(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/carts/".concat(s, "/line-items");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "update",
      value: function update(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/store/carts/".concat(s, "/line-items/").concat(e);
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "delete",
      value: function _delete(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/carts/".concat(s, "/line-items/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }]);
    return G;
  }(i),
  D = G;
var L = /*#__PURE__*/function (_i4) {
    _inherits(L, _i4);
    var _super10 = _createSuper(L);
    function L() {
      var _this3;
      _classCallCheck(this, L);
      _this3 = _super10.apply(this, arguments);
      _this3.lineItems = new D(_this3.client);
      return _this3;
    }
    _createClass(L, [{
      key: "addShippingMethod",
      value: function addShippingMethod(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var n = "/store/carts/".concat(e, "/shipping-methods");
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "complete",
      value: function complete(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/carts/".concat(e, "/complete");
        return this.client.request("POST", r, void 0, {}, t);
      }
    }, {
      key: "create",
      value: function create(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/carts";
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "createPaymentSessions",
      value: function createPaymentSessions(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/carts/".concat(e, "/payment-sessions");
        return this.client.request("POST", r, void 0, {}, t);
      }
    }, {
      key: "deleteDiscount",
      value: function deleteDiscount(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var n = "/store/carts/".concat(e, "/discounts/").concat(t);
        return this.client.request("DELETE", n, void 0, {}, r);
      }
    }, {
      key: "deletePaymentSession",
      value: function deletePaymentSession(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var n = "/store/carts/".concat(e, "/payment-sessions/").concat(t);
        return this.client.request("DELETE", n, void 0, {}, r);
      }
    }, {
      key: "refreshPaymentSession",
      value: function refreshPaymentSession(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var n = "/store/carts/".concat(e, "/payment-sessions/").concat(t, "/refresh");
        return this.client.request("POST", n, void 0, {}, r);
      }
    }, {
      key: "retrieve",
      value: function retrieve(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/carts/".concat(e);
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "setPaymentSession",
      value: function setPaymentSession(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var n = "/store/carts/".concat(e, "/payment-session");
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "update",
      value: function update(e, t) {
        var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var n = "/store/carts/".concat(e);
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "updatePaymentSession",
      value: function updatePaymentSession(e, t, r) {
        var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var a = "/store/carts/".concat(e, "/payment-sessions/").concat(t);
        return this.client.request("POST", a, r, {}, n);
      }
    }]);
    return L;
  }(i),
  b = L;
import Fs from "qs";
var w = /*#__PURE__*/function (_i5) {
    _inherits(w, _i5);
    var _super11 = _createSuper(w);
    function w() {
      _classCallCheck(this, w);
      return _super11.apply(this, arguments);
    }
    _createClass(w, [{
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/collections/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/collections";
        return s && (t = "/store/collections?".concat(Fs.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return w;
  }(i),
  v = w;
import Ms from "qs";
var B = /*#__PURE__*/function (_i6) {
    _inherits(B, _i6);
    var _super12 = _createSuper(B);
    function B() {
      _classCallCheck(this, B);
      return _super12.apply(this, arguments);
    }
    _createClass(B, [{
      key: "list",
      value: function list() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/store/customers/me/payment-methods";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }]);
    return B;
  }(i),
  R = B;
var I = /*#__PURE__*/function (_i7) {
    _inherits(I, _i7);
    var _super13 = _createSuper(I);
    function I() {
      var _this4;
      _classCallCheck(this, I);
      _this4 = _super13.apply(this, arguments);
      _this4.paymentMethods = new R(_this4.client);
      _this4.addresses = new $(_this4.client);
      return _this4;
    }
    _createClass(I, [{
      key: "create",
      value: function create(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/customers";
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "retrieve",
      value: function retrieve() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t = "/store/customers/me";
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "update",
      value: function update(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/customers/me";
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "listOrders",
      value: function listOrders(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/customers/me/orders";
        if (e) {
          var n = Ms.stringify(e);
          n && (r += "?".concat(n));
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "resetPassword",
      value: function resetPassword(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/customers/password-reset";
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "generatePasswordToken",
      value: function generatePasswordToken(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/customers/password-token";
        return this.client.request("POST", r, e, {}, t);
      }
    }]);
    return I;
  }(i),
  k = I;
var U = /*#__PURE__*/function (_i8) {
    _inherits(U, _i8);
    var _super14 = _createSuper(U);
    function U() {
      _classCallCheck(this, U);
      return _super14.apply(this, arguments);
    }
    _createClass(U, [{
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/gift-cards/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return U;
  }(i),
  K = U;
var N = /*#__PURE__*/function (_i9) {
    _inherits(N, _i9);
    var _super15 = _createSuper(N);
    function N() {
      _classCallCheck(this, N);
      return _super15.apply(this, arguments);
    }
    _createClass(N, [{
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/order-edits/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "decline",
      value: function decline(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/order-edits/".concat(s, "/decline");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "complete",
      value: function complete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/order-edits/".concat(s, "/complete");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }]);
    return N;
  }(i),
  V = N;
import zs from "qs";
var F = /*#__PURE__*/function (_i10) {
    _inherits(F, _i10);
    var _super16 = _createSuper(F);
    function F() {
      _classCallCheck(this, F);
      return _super16.apply(this, arguments);
    }
    _createClass(F, [{
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/orders/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "retrieveByCartId",
      value: function retrieveByCartId(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/orders/cart/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "lookupOrder",
      value: function lookupOrder(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/orders?";
        return t = "/store/orders?".concat(zs.stringify(s)), this.client.request("GET", t, s, {}, e);
      }
    }, {
      key: "requestCustomerOrders",
      value: function requestCustomerOrders(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/orders/batch/customer/token";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "confirmRequest",
      value: function confirmRequest(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/orders/customer/confirm";
        return this.client.request("POST", t, s, {}, e);
      }
    }]);
    return F;
  }(i),
  M = F;
import Hs from "qs";
var z = /*#__PURE__*/function (_i11) {
    _inherits(z, _i11);
    var _super17 = _createSuper(z);
    function z() {
      _classCallCheck(this, z);
      return _super17.apply(this, arguments);
    }
    _createClass(z, [{
      key: "retrieve",
      value: function retrieve(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/payment-collections/".concat(s);
        if (e) {
          var n = Hs.stringify(e);
          r += "?".concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "authorizePaymentSession",
      value: function authorizePaymentSession(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/payment-collections/".concat(s, "/sessions/").concat(e, "/authorize");
        return this.client.request("POST", r, void 0, {}, t);
      }
    }, {
      key: "authorizePaymentSessionsBatch",
      value: function authorizePaymentSessionsBatch(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/payment-collections/".concat(s, "/sessions/batch/authorize");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "managePaymentSessionsBatch",
      value: function managePaymentSessionsBatch(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/payment-collections/".concat(s, "/sessions/batch");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "managePaymentSession",
      value: function managePaymentSession(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/payment-collections/".concat(s, "/sessions");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "refreshPaymentSession",
      value: function refreshPaymentSession(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/payment-collections/".concat(s, "/sessions/").concat(e);
        return this.client.request("POST", r, void 0, {}, t);
      }
    }]);
    return z;
  }(i),
  H = z;
import We from "qs";
var j = /*#__PURE__*/function (_i12) {
    _inherits(j, _i12);
    var _super18 = _createSuper(j);
    function j() {
      _classCallCheck(this, j);
      return _super18.apply(this, arguments);
    }
    _createClass(j, [{
      key: "retrieve",
      value: function retrieve(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/store/product-categories/".concat(s);
        if (e) {
          var n = We.stringify(e);
          r = "".concat(r, "?").concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/product-categories";
        if (s) {
          var r = We.stringify(s);
          t = "".concat(t, "?").concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return j;
  }(i),
  J = j;
import js from "qs";
var _ = /*#__PURE__*/function (_i13) {
    _inherits(_, _i13);
    var _super19 = _createSuper(_);
    function _() {
      _classCallCheck(this, _);
      return _super19.apply(this, arguments);
    }
    _createClass(_, [{
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/product-tags";
        if (s) {
          var r = js.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return _;
  }(i),
  Q = _;
import Js from "qs";
var W = /*#__PURE__*/function (_i14) {
    _inherits(W, _i14);
    var _super20 = _createSuper(W);
    function W() {
      _classCallCheck(this, W);
      return _super20.apply(this, arguments);
    }
    _createClass(W, [{
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/product-types";
        if (s) {
          var r = Js.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return W;
  }(i),
  X = W;
import Qs from "qs";
import _s from "qs";
var Y = /*#__PURE__*/function (_i15) {
    _inherits(Y, _i15);
    var _super21 = _createSuper(Y);
    function Y() {
      _classCallCheck(this, Y);
      return _super21.apply(this, arguments);
    }
    _createClass(Y, [{
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/variants/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/variants";
        if (s) {
          var r = _s.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return Y;
  }(i),
  Xe = Y;
var Z = /*#__PURE__*/function (_i16) {
    _inherits(Z, _i16);
    var _super22 = _createSuper(Z);
    function Z() {
      var _this5;
      _classCallCheck(this, Z);
      _this5 = _super22.apply(this, arguments);
      _this5.variants = new Xe(_this5.client);
      return _this5;
    }
    _createClass(Z, [{
      key: "retrieve",
      value: function retrieve(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/products/".concat(e);
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "search",
      value: function search(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/products/search";
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "list",
      value: function list(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/store/products";
        return e && (r = "/store/products?".concat(Qs.stringify(e))), this.client.request("GET", r, void 0, {}, t);
      }
    }]);
    return Z;
  }(i),
  ee = Z;
var se = /*#__PURE__*/function (_i17) {
    _inherits(se, _i17);
    var _super23 = _createSuper(se);
    function se() {
      _classCallCheck(this, se);
      return _super23.apply(this, arguments);
    }
    _createClass(se, [{
      key: "list",
      value: function list() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/store/regions";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/regions/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return se;
  }(i),
  te = se;
var re = /*#__PURE__*/function (_i18) {
    _inherits(re, _i18);
    var _super24 = _createSuper(re);
    function re() {
      _classCallCheck(this, re);
      return _super24.apply(this, arguments);
    }
    _createClass(re, [{
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/return-reasons/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/store/return-reasons";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }]);
    return re;
  }(i),
  ne = re;
var ie = /*#__PURE__*/function (_i19) {
    _inherits(ie, _i19);
    var _super25 = _createSuper(ie);
    function ie() {
      _classCallCheck(this, ie);
      return _super25.apply(this, arguments);
    }
    _createClass(ie, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/returns";
        return this.client.request("POST", t, s, {}, e);
      }
    }]);
    return ie;
  }(i),
  oe = ie;
import Ws from "qs";
var ae = /*#__PURE__*/function (_i20) {
    _inherits(ae, _i20);
    var _super26 = _createSuper(ae);
    function ae() {
      _classCallCheck(this, ae);
      return _super26.apply(this, arguments);
    }
    _createClass(ae, [{
      key: "listCartOptions",
      value: function listCartOptions(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/shipping-options/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/shipping-options";
        return s && (t = "/store/shipping-options?".concat(Ws.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return ae;
  }(i),
  de = ae;
var me = /*#__PURE__*/function (_i21) {
    _inherits(me, _i21);
    var _super27 = _createSuper(me);
    function me() {
      _classCallCheck(this, me);
      return _super27.apply(this, arguments);
    }
    _createClass(me, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/swaps";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "retrieveByCartId",
      value: function retrieveByCartId(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/store/swaps/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return me;
  }(i),
  ce = me;
var ue = /*#__PURE__*/function (_i22) {
    _inherits(ue, _i22);
    var _super28 = _createSuper(ue);
    function ue() {
      _classCallCheck(this, ue);
      return _super28.apply(this, arguments);
    }
    _createClass(ue, [{
      key: "getSession",
      value: function getSession() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/auth";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }, {
      key: "deleteSession",
      value: function deleteSession() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/auth";
        return this.client.request("DELETE", e, void 0, {}, s);
      }
    }, {
      key: "createSession",
      value: function createSession(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/auth";
        return this.client.request("POST", t, s, {}, e);
      }
    }]);
    return ue;
  }(i),
  Ye = ue;
import Xs from "qs";
function Ze(o) {
  var s = function s(e) {
    var t = {};
    return Object.keys(e).reduce(function (r, n) {
      return e[n] === null ? r[n] = "null" : typeof e[n] == "object" ? r[n] = s(e[n]) : r[n] = e[n], r;
    }, t), t;
  };
  return s(o);
}
var pe = /*#__PURE__*/function (_i23) {
    _inherits(pe, _i23);
    var _super29 = _createSuper(pe);
    function pe() {
      _classCallCheck(this, pe);
      return _super29.apply(this, arguments);
    }
    _createClass(pe, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/batch-jobs";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/batch-jobs";
        return s && (t = "/admin/batch-jobs?".concat(Xs.stringify(Ze(s)))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "cancel",
      value: function cancel(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/batch-jobs/".concat(s, "/cancel");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "confirm",
      value: function confirm(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/batch-jobs/".concat(s, "/confirm");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/batch-jobs/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return pe;
  }(i),
  es = pe;
import Ys from "qs";
var Re = /*#__PURE__*/function (_i24) {
    _inherits(Re, _i24);
    var _super30 = _createSuper(Re);
    function Re() {
      _classCallCheck(this, Re);
      return _super30.apply(this, arguments);
    }
    _createClass(Re, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/collections";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/collections/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/collections/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/collections/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/collections";
        return s && (t = "/admin/collections?".concat(Ys.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "addProducts",
      value: function addProducts(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/collections/".concat(s, "/products/batch");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "removeProducts",
      value: function removeProducts(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/collections/".concat(s, "/products/batch");
        return this.client.request("DELETE", r, e, {}, t);
      }
    }]);
    return Re;
  }(i),
  ss = Re;
import Zs from "qs";
var le = /*#__PURE__*/function (_i25) {
    _inherits(le, _i25);
    var _super31 = _createSuper(le);
    function le() {
      _classCallCheck(this, le);
      return _super31.apply(this, arguments);
    }
    _createClass(le, [{
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/currencies";
        if (s) {
          var r = Zs.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/currencies/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }]);
    return le;
  }(i),
  ts = le;
import Pe from "qs";
var he = /*#__PURE__*/function (_i26) {
    _inherits(he, _i26);
    var _super32 = _createSuper(he);
    function he() {
      _classCallCheck(this, he);
      return _super32.apply(this, arguments);
    }
    _createClass(he, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/customer-groups";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/customer-groups/".concat(s);
        if (e) {
          var n = Pe.stringify(e);
          r += "?".concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/customer-groups/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/customer-groups/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/customer-groups";
        return s && (t = "/admin/customer-groups?".concat(Pe.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "addCustomers",
      value: function addCustomers(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/customer-groups/".concat(s, "/customers/batch");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "removeCustomers",
      value: function removeCustomers(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/customer-groups/".concat(s, "/customers/batch");
        return this.client.request("DELETE", r, e, {}, t);
      }
    }, {
      key: "listCustomers",
      value: function listCustomers(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/customer-groups/".concat(s, "/customers");
        if (e) {
          var n = Pe.stringify(e);
          r += "?".concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }]);
    return he;
  }(i),
  rs = he;
import et from "qs";
var ge = /*#__PURE__*/function (_i27) {
    _inherits(ge, _i27);
    var _super33 = _createSuper(ge);
    function ge() {
      _classCallCheck(this, ge);
      return _super33.apply(this, arguments);
    }
    _createClass(ge, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/customers";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/customers/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/customers/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/customers";
        return s && (t = "/admin/customers?".concat(et.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return ge;
  }(i),
  ns = ge;
import l from "qs";
var fe = /*#__PURE__*/function (_i28) {
    _inherits(fe, _i28);
    var _super34 = _createSuper(fe);
    function fe() {
      _classCallCheck(this, fe);
      return _super34.apply(this, arguments);
    }
    _createClass(fe, [{
      key: "addRegion",
      value: function addRegion(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/discounts/".concat(s, "/regions/").concat(e);
        return this.client.request("POST", r, void 0, {}, t);
      }
    }, {
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/discounts";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/discounts/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "createDynamicCode",
      value: function createDynamicCode(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/discounts/".concat(s, "/dynamic-codes");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/discounts/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "deleteDynamicCode",
      value: function deleteDynamicCode(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/discounts/".concat(s, "/dynamic-codes/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/discounts/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "retrieveByCode",
      value: function retrieveByCode(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/discounts/code/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/discounts";
        if (s) {
          var r = l.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "removeRegion",
      value: function removeRegion(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/discounts/".concat(s, "/regions/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }, {
      key: "createCondition",
      value: function createCondition(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/discounts/".concat(s, "/conditions");
        if (t) {
          var a = l.stringify(t);
          n += "?".concat(a);
        }
        return this.client.request("POST", n, e, {}, r);
      }
    }, {
      key: "updateCondition",
      value: function updateCondition(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        var a = "/admin/discounts/".concat(s, "/conditions/").concat(e);
        if (r) {
          var u = l.stringify(r);
          a += "?".concat(u);
        }
        return this.client.request("POST", a, t, {}, n);
      }
    }, {
      key: "deleteCondition",
      value: function deleteCondition(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/discounts/".concat(s, "/conditions/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }, {
      key: "getCondition",
      value: function getCondition(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/discounts/".concat(s, "/conditions/").concat(e);
        if (t) {
          var a = l.stringify(t);
          n += "?".concat(a);
        }
        return this.client.request("GET", n, void 0, {}, r);
      }
    }, {
      key: "addConditionResourceBatch",
      value: function addConditionResourceBatch(s, e, t, r) {
        var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        var a = "/admin/discounts/".concat(s, "/conditions/").concat(e, "/batch");
        if (r) {
          var u = l.stringify(r);
          a += "?".concat(u);
        }
        return this.client.request("POST", a, t, {}, n);
      }
    }, {
      key: "deleteConditionResourceBatch",
      value: function deleteConditionResourceBatch(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/discounts/".concat(s, "/conditions/").concat(e, "/batch");
        return this.client.request("DELETE", n, t, {}, r);
      }
    }]);
    return fe;
  }(i),
  is = fe;
import st from "qs";
var Ae = /*#__PURE__*/function (_i29) {
    _inherits(Ae, _i29);
    var _super35 = _createSuper(Ae);
    function Ae() {
      _classCallCheck(this, Ae);
      return _super35.apply(this, arguments);
    }
    _createClass(Ae, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/draft-orders";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "addLineItem",
      value: function addLineItem(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/draft-orders/".concat(s, "/line-items");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/draft-orders/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "removeLineItem",
      value: function removeLineItem(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/draft-orders/".concat(s, "/line-items/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/draft-orders/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/draft-orders";
        return s && (t = "/admin/draft-orders?".concat(st.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "markPaid",
      value: function markPaid(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/draft-orders/".concat(s, "/pay");
        return this.client.request("POST", t, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/draft-orders/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "updateLineItem",
      value: function updateLineItem(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/draft-orders/".concat(s, "/line-items/").concat(e);
        return this.client.request("POST", n, t, {}, r);
      }
    }]);
    return Ae;
  }(i),
  os = Ae;
import tt from "qs";
var ye = /*#__PURE__*/function (_i30) {
    _inherits(ye, _i30);
    var _super36 = _createSuper(ye);
    function ye() {
      _classCallCheck(this, ye);
      return _super36.apply(this, arguments);
    }
    _createClass(ye, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/gift-cards";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/gift-cards/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/gift-cards/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/gift-cards/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/gift-cards/";
        return s && (t = "/admin/gift-cards?".concat(tt.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return ye;
  }(i),
  as = ye;
var qe = /*#__PURE__*/function (_i31) {
    _inherits(qe, _i31);
    var _super37 = _createSuper(qe);
    function qe() {
      _classCallCheck(this, qe);
      return _super37.apply(this, arguments);
    }
    _createClass(qe, [{
      key: "accept",
      value: function accept(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/invites/accept";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/invites";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/invites/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/invites";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }, {
      key: "resend",
      value: function resend(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/invites/".concat(s);
        return this.client.request("POST", t, void 0, {}, e);
      }
    }]);
    return qe;
  }(i),
  ds = qe;
import rt from "qs";
var Se = /*#__PURE__*/function (_i32) {
    _inherits(Se, _i32);
    var _super38 = _createSuper(Se);
    function Se() {
      _classCallCheck(this, Se);
      return _super38.apply(this, arguments);
    }
    _createClass(Se, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/notes";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/notes/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/notes/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/notes/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/notes/";
        return s && (t = "/admin/notes?".concat(rt.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return Se;
  }(i),
  ms = Se;
import nt from "qs";
var Ce = /*#__PURE__*/function (_i33) {
    _inherits(Ce, _i33);
    var _super39 = _createSuper(Ce);
    function Ce() {
      _classCallCheck(this, Ce);
      return _super39.apply(this, arguments);
    }
    _createClass(Ce, [{
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/notifications";
        return s && (t = "/admin/notifications?".concat(nt.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "resend",
      value: function resend(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/notifications/".concat(s, "/resend");
        return this.client.request("POST", r, e, {}, t);
      }
    }]);
    return Ce;
  }(i),
  cs = Ce;
import us from "qs";
var Te = /*#__PURE__*/function (_i34) {
    _inherits(Te, _i34);
    var _super40 = _createSuper(Te);
    function Te() {
      _classCallCheck(this, Te);
      return _super40.apply(this, arguments);
    }
    _createClass(Te, [{
      key: "retrieve",
      value: function retrieve(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/order-edits/".concat(s);
        if (e) {
          var n = us.stringify(e);
          r += "?".concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/order-edits";
        if (s) {
          var r = us.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/order-edits";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/order-edits/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/order-edits/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "addLineItem",
      value: function addLineItem(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/order-edits/".concat(s, "/items");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "deleteItemChange",
      value: function deleteItemChange(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/order-edits/".concat(s, "/changes/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }, {
      key: "requestConfirmation",
      value: function requestConfirmation(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/order-edits/".concat(s, "/request");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "cancel",
      value: function cancel(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/order-edits/".concat(s, "/cancel");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "confirm",
      value: function confirm(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/order-edits/".concat(s, "/confirm");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "updateLineItem",
      value: function updateLineItem(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/order-edits/".concat(s, "/items/").concat(e);
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "removeLineItem",
      value: function removeLineItem(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/order-edits/".concat(s, "/items/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }]);
    return Te;
  }(i),
  ps = Te;
import Rs from "qs";
var Oe = /*#__PURE__*/function (_i35) {
    _inherits(Oe, _i35);
    var _super41 = _createSuper(Oe);
    function Oe() {
      _classCallCheck(this, Oe);
      return _super41.apply(this, arguments);
    }
    _createClass(Oe, [{
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s);
        if (e) {
          var n = Rs.stringify(e);
          r = "/admin/orders/".concat(s, "?").concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/orders";
        return s && (t = "/admin/orders?".concat(Rs.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "complete",
      value: function complete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/orders/".concat(s, "/complete");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "capturePayment",
      value: function capturePayment(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/orders/".concat(s, "/capture");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "refundPayment",
      value: function refundPayment(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/refund");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "createFulfillment",
      value: function createFulfillment(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/fulfillment");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "cancelFulfillment",
      value: function cancelFulfillment(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/fulfillments/").concat(e, "/cancel");
        return this.client.request("POST", r, void 0, {}, t);
      }
    }, {
      key: "cancelSwapFulfillment",
      value: function cancelSwapFulfillment(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/orders/".concat(s, "/swaps/").concat(e, "/fulfillments/").concat(t, "/cancel");
        return this.client.request("POST", n, void 0, {}, r);
      }
    }, {
      key: "cancelClaimFulfillment",
      value: function cancelClaimFulfillment(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/orders/".concat(s, "/claims/").concat(e, "/fulfillments/").concat(t, "/cancel");
        return this.client.request("POST", n, void 0, {}, r);
      }
    }, {
      key: "createShipment",
      value: function createShipment(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/shipment");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "requestReturn",
      value: function requestReturn(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/return");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "cancel",
      value: function cancel(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/orders/".concat(s, "/cancel");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "addShippingMethod",
      value: function addShippingMethod(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/shipping-methods");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "archive",
      value: function archive(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/orders/".concat(s, "/archive");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "createSwap",
      value: function createSwap(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/swaps");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "cancelSwap",
      value: function cancelSwap(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/swaps/").concat(e, "/cancel");
        return this.client.request("POST", r, void 0, {}, t);
      }
    }, {
      key: "fulfillSwap",
      value: function fulfillSwap(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/orders/".concat(s, "/swaps/").concat(e, "/fulfillments");
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "createSwapShipment",
      value: function createSwapShipment(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/orders/".concat(s, "/swaps/").concat(e, "/shipments");
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "processSwapPayment",
      value: function processSwapPayment(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/swaps/").concat(e, "/process-payment");
        return this.client.request("POST", r, void 0, {}, t);
      }
    }, {
      key: "createClaim",
      value: function createClaim(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/claims");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "cancelClaim",
      value: function cancelClaim(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/orders/".concat(s, "/claims/").concat(e, "/cancel");
        return this.client.request("POST", r, void 0, {}, t);
      }
    }, {
      key: "updateClaim",
      value: function updateClaim(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/orders/".concat(s, "/claims/").concat(e);
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "fulfillClaim",
      value: function fulfillClaim(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/orders/".concat(s, "/claims/").concat(e, "/fulfillments");
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "createClaimShipment",
      value: function createClaimShipment(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/orders/".concat(s, "/claims/").concat(e, "/shipments");
        return this.client.request("POST", n, t, {}, r);
      }
    }]);
    return Oe;
  }(i),
  ls = Oe;
import it from "qs";
var $e = /*#__PURE__*/function (_i36) {
    _inherits($e, _i36);
    var _super42 = _createSuper($e);
    function $e() {
      _classCallCheck(this, $e);
      return _super42.apply(this, arguments);
    }
    _createClass($e, [{
      key: "retrieve",
      value: function retrieve(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/payment-collections/".concat(s);
        if (e) {
          var n = it.stringify(e);
          r += "?".concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/payment-collections/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/payment-collections/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "markAsAuthorized",
      value: function markAsAuthorized(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/payment-collections/".concat(s, "/authorize");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }]);
    return $e;
  }(i),
  Ps = $e;
import ot from "qs";
var Ee = /*#__PURE__*/function (_i37) {
    _inherits(Ee, _i37);
    var _super43 = _createSuper(Ee);
    function Ee() {
      _classCallCheck(this, Ee);
      return _super43.apply(this, arguments);
    }
    _createClass(Ee, [{
      key: "retrieve",
      value: function retrieve(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/payments/".concat(s);
        if (e) {
          var n = ot.stringify(e);
          r = "/admin/payments/".concat(s, "?").concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "capturePayment",
      value: function capturePayment(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/payments/".concat(s, "/capture");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "refundPayment",
      value: function refundPayment(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/payments/".concat(s, "/refund");
        return this.client.request("POST", r, e, {}, t);
      }
    }]);
    return Ee;
  }(i),
  hs = Ee;
import gs from "qs";
var xe = /*#__PURE__*/function (_i38) {
    _inherits(xe, _i38);
    var _super44 = _createSuper(xe);
    function xe() {
      _classCallCheck(this, xe);
      return _super44.apply(this, arguments);
    }
    _createClass(xe, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/price-lists";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/price-lists/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/price-lists/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/price-lists/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/price-lists/";
        return s && (t = "/admin/price-lists?".concat(gs.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "listProducts",
      value: function listProducts(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/price-lists/".concat(s, "/products");
        if (e) {
          var n = gs.stringify(e);
          r = "/admin/price-lists/".concat(s, "/products?").concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "addPrices",
      value: function addPrices(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/price-lists/".concat(s, "/prices/batch");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "deletePrices",
      value: function deletePrices(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/price-lists/".concat(s, "/prices/batch");
        return this.client.request("DELETE", r, e, {}, t);
      }
    }, {
      key: "deleteProductPrices",
      value: function deleteProductPrices(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/price-lists/".concat(s, "/products/").concat(e, "/prices");
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }, {
      key: "deleteVariantPrices",
      value: function deleteVariantPrices(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/price-lists/".concat(s, "/variants/").concat(e, "/prices");
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }]);
    return xe;
  }(i),
  fs = xe;
import As from "qs";
var Ge = /*#__PURE__*/function (_i39) {
    _inherits(Ge, _i39);
    var _super45 = _createSuper(Ge);
    function Ge() {
      _classCallCheck(this, Ge);
      return _super45.apply(this, arguments);
    }
    _createClass(Ge, [{
      key: "retrieve",
      value: function retrieve(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/product-categories/".concat(s);
        if (e) {
          var n = As.stringify(e);
          r = "".concat(r, "?").concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/product-categories";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/product-categories/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/product-categories";
        if (s) {
          var r = As.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/product-categories/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "removeProducts",
      value: function removeProducts(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/product-categories/".concat(s, "/products/batch");
        return this.client.request("DELETE", r, e, {}, t);
      }
    }, {
      key: "addProducts",
      value: function addProducts(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/product-categories/".concat(s, "/products/batch");
        return this.client.request("POST", r, e, {}, t);
      }
    }]);
    return Ge;
  }(i),
  ys = Ge;
import at from "qs";
var De = /*#__PURE__*/function (_i40) {
    _inherits(De, _i40);
    var _super46 = _createSuper(De);
    function De() {
      _classCallCheck(this, De);
      return _super46.apply(this, arguments);
    }
    _createClass(De, [{
      key: "list",
      value: function list(s) {
        var e = "/admin/product-tags";
        return s && (e = "/admin/product-tags?".concat(at.stringify(s))), this.client.request("GET", e);
      }
    }]);
    return De;
  }(i),
  qs = De;
import dt from "qs";
var Le = /*#__PURE__*/function (_i41) {
    _inherits(Le, _i41);
    var _super47 = _createSuper(Le);
    function Le() {
      _classCallCheck(this, Le);
      return _super47.apply(this, arguments);
    }
    _createClass(Le, [{
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/product-types";
        if (s) {
          var r = dt.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return Le;
  }(i),
  Ss = Le;
import mt from "qs";
var be = /*#__PURE__*/function (_i42) {
    _inherits(be, _i42);
    var _super48 = _createSuper(be);
    function be() {
      _classCallCheck(this, be);
      return _super48.apply(this, arguments);
    }
    _createClass(be, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/products/";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/products/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/products/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/products/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/products";
        return s && (t = "/admin/products?".concat(mt.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "listTypes",
      value: function listTypes() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/products/types";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }, {
      key: "listTags",
      value: function listTags() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/products/tag-usage";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }, {
      key: "setMetadata",
      value: function setMetadata(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/products/".concat(s, "/metadata");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "createVariant",
      value: function createVariant(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/products/".concat(s, "/variants");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "updateVariant",
      value: function updateVariant(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/products/".concat(s, "/variants/").concat(e);
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "deleteVariant",
      value: function deleteVariant(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/products/".concat(s, "/variants/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }, {
      key: "addOption",
      value: function addOption(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/products/".concat(s, "/options");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "updateOption",
      value: function updateOption(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/products/".concat(s, "/options/").concat(e);
        return this.client.request("POST", n, t, {}, r);
      }
    }, {
      key: "deleteOption",
      value: function deleteOption(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/products/".concat(s, "/options/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }]);
    return be;
  }(i),
  Cs = be;
import we from "qs";
var ve = /*#__PURE__*/function (_i43) {
    _inherits(ve, _i43);
    var _super49 = _createSuper(ve);
    function ve() {
      _classCallCheck(this, ve);
      return _super49.apply(this, arguments);
    }
    _createClass(ve, [{
      key: "retrieve",
      value: function retrieve(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/publishable-api-keys/".concat(s);
        if (e) {
          var n = we.stringify(e);
          r += "?".concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/publishable-api-keys";
        if (s) {
          var r = we.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/publishable-api-keys";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/publishable-api-keys/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/publishable-api-keys/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "revoke",
      value: function revoke(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/publishable-api-keys/".concat(s, "/revoke");
        return this.client.request("POST", t, {}, {}, e);
      }
    }, {
      key: "addSalesChannelsBatch",
      value: function addSalesChannelsBatch(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/publishable-api-keys/".concat(s, "/sales-channels/batch");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "deleteSalesChannelsBatch",
      value: function deleteSalesChannelsBatch(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/publishable-api-keys/".concat(s, "/sales-channels/batch");
        return this.client.request("DELETE", r, e, {}, t);
      }
    }, {
      key: "listSalesChannels",
      value: function listSalesChannels(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/publishable-api-keys/".concat(s, "/sales-channels");
        if (e) {
          var n = we.stringify(e);
          r += "?".concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }]);
    return ve;
  }(i),
  Ts = ve;
import ct from "qs";
var Be = /*#__PURE__*/function (_i44) {
    _inherits(Be, _i44);
    var _super50 = _createSuper(Be);
    function Be() {
      _classCallCheck(this, Be);
      return _super50.apply(this, arguments);
    }
    _createClass(Be, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/regions";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/regions/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/regions/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/regions/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/regions";
        return s && (t = "/admin/regions?".concat(ct.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "addCountry",
      value: function addCountry(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/regions/".concat(s, "/countries");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "deleteCountry",
      value: function deleteCountry(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/regions/".concat(s, "/countries/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }, {
      key: "addFulfillmentProvider",
      value: function addFulfillmentProvider(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/regions/".concat(s, "/fulfillment-providers");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "deleteFulfillmentProvider",
      value: function deleteFulfillmentProvider(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/regions/".concat(s, "/fulfillment-providers/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }, {
      key: "retrieveFulfillmentOptions",
      value: function retrieveFulfillmentOptions(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/regions/".concat(s, "/fulfillment-options");
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "addPaymentProvider",
      value: function addPaymentProvider(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/regions/".concat(s, "/payment-providers");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "deletePaymentProvider",
      value: function deletePaymentProvider(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/regions/".concat(s, "/payment-providers/").concat(e);
        return this.client.request("DELETE", r, void 0, {}, t);
      }
    }]);
    return Be;
  }(i),
  Os = Be;
var Ie = /*#__PURE__*/function (_i45) {
    _inherits(Ie, _i45);
    var _super51 = _createSuper(Ie);
    function Ie() {
      _classCallCheck(this, Ie);
      return _super51.apply(this, arguments);
    }
    _createClass(Ie, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/return-reasons";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/return-reasons/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/return-reasons/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/return-reasons/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/return-reasons";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }]);
    return Ie;
  }(i),
  $s = Ie;
import ut from "qs";
var ke = /*#__PURE__*/function (_i46) {
    _inherits(ke, _i46);
    var _super52 = _createSuper(ke);
    function ke() {
      _classCallCheck(this, ke);
      return _super52.apply(this, arguments);
    }
    _createClass(ke, [{
      key: "cancel",
      value: function cancel(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/returns/".concat(s, "/cancel");
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "receive",
      value: function receive(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/returns/".concat(s, "/receive");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/returns/";
        return s && (t = "/admin/returns?".concat(ut.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return ke;
  }(i),
  Es = ke;
import pt from "qs";
var Ue = /*#__PURE__*/function (_i47) {
    _inherits(Ue, _i47);
    var _super53 = _createSuper(Ue);
    function Ue() {
      _classCallCheck(this, Ue);
      return _super53.apply(this, arguments);
    }
    _createClass(Ue, [{
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/sales-channels/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/sales-channels";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/sales-channels/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/sales-channels";
        if (s) {
          var r = pt.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/sales-channels/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "removeProducts",
      value: function removeProducts(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/sales-channels/".concat(s, "/products/batch");
        return this.client.request("DELETE", r, e, {}, t);
      }
    }, {
      key: "addProducts",
      value: function addProducts(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/sales-channels/".concat(s, "/products/batch");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "addLocation",
      value: function addLocation(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/sales-channels/".concat(s, "/stock-locations");
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "removeLocation",
      value: function removeLocation(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/sales-channels/".concat(s, "/stock-locations");
        return this.client.request("DELETE", r, e, {}, t);
      }
    }]);
    return Ue;
  }(i),
  xs = Ue;
import Rt from "qs";
var Ke = /*#__PURE__*/function (_i48) {
    _inherits(Ke, _i48);
    var _super54 = _createSuper(Ke);
    function Ke() {
      _classCallCheck(this, Ke);
      return _super54.apply(this, arguments);
    }
    _createClass(Ke, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/shipping-options";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/shipping-options/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/shipping-options/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/shipping-options/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/shipping-options";
        return s && (t = "/admin/shipping-options?".concat(Rt.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return Ke;
  }(i),
  Gs = Ke;
var Ne = /*#__PURE__*/function (_i49) {
    _inherits(Ne, _i49);
    var _super55 = _createSuper(Ne);
    function Ne() {
      _classCallCheck(this, Ne);
      return _super55.apply(this, arguments);
    }
    _createClass(Ne, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/shipping-profiles/";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/shipping-profiles/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/shipping-profiles/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/shipping-profiles/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/shipping-profiles/";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }]);
    return Ne;
  }(i),
  Ds = Ne;
import lt from "qs";
var Ve = /*#__PURE__*/function (_i50) {
    _inherits(Ve, _i50);
    var _super56 = _createSuper(Ve);
    function Ve() {
      _classCallCheck(this, Ve);
      return _super56.apply(this, arguments);
    }
    _createClass(Ve, [{
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/stock-locations";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/stock-locations/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/stock-locations/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/stock-locations/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/stock-locations";
        if (s) {
          var r = lt.stringify(s);
          t += "?".concat(r);
        }
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return Ve;
  }(i),
  Ls = Ve;
var Fe = /*#__PURE__*/function (_i51) {
    _inherits(Fe, _i51);
    var _super57 = _createSuper(Fe);
    function Fe() {
      _classCallCheck(this, Fe);
      return _super57.apply(this, arguments);
    }
    _createClass(Fe, [{
      key: "update",
      value: function update(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/store/";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "addCurrency",
      value: function addCurrency(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/store/".concat(s);
        return this.client.request("POST", t, void 0, {}, e);
      }
    }, {
      key: "deleteCurrency",
      value: function deleteCurrency(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/store/currencies/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/store/";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }, {
      key: "listPaymentProviders",
      value: function listPaymentProviders() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/store/payment-providers";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }, {
      key: "listTaxProviders",
      value: function listTaxProviders() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/store/tax-providers";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }]);
    return Fe;
  }(i),
  bs = Fe;
import Pt from "qs";
var Me = /*#__PURE__*/function (_i52) {
    _inherits(Me, _i52);
    var _super58 = _createSuper(Me);
    function Me() {
      _classCallCheck(this, Me);
      return _super58.apply(this, arguments);
    }
    _createClass(Me, [{
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/swaps/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/swaps/";
        return s && (t = "/admin/swaps?".concat(Pt.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return Me;
  }(i),
  ws = Me;
import m from "qs";
var ze = /*#__PURE__*/function (_i53) {
    _inherits(ze, _i53);
    var _super59 = _createSuper(ze);
    function ze() {
      _classCallCheck(this, ze);
      return _super59.apply(this, arguments);
    }
    _createClass(ze, [{
      key: "retrieve",
      value: function retrieve(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/tax-rates/".concat(s);
        if (e) {
          var n = m.stringify(e);
          r = "/admin/tax-rates/".concat(s, "?").concat(n);
        }
        return this.client.request("GET", r, void 0, {}, t);
      }
    }, {
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/tax-rates";
        return s && (t = "/admin/tax-rates?".concat(m.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "create",
      value: function create(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/tax-rates";
        return e && (r = "/admin/tax-rates?".concat(m.stringify(e))), this.client.request("POST", r, s, {}, t);
      }
    }, {
      key: "update",
      value: function update(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/tax-rates/".concat(s);
        if (t) {
          var a = m.stringify(t);
          n = "/admin/tax-rates/".concat(s, "?").concat(a);
        }
        return this.client.request("POST", n, e, {}, r);
      }
    }, {
      key: "addProducts",
      value: function addProducts(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/tax-rates/".concat(s, "/products/batch");
        if (t) {
          var a = m.stringify(t);
          n = "/admin/tax-rates/".concat(s, "/products/batch?").concat(a);
        }
        return this.client.request("POST", n, e, {}, r);
      }
    }, {
      key: "addProductTypes",
      value: function addProductTypes(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/tax-rates/".concat(s, "/product-types/batch");
        if (t) {
          var a = m.stringify(t);
          n = "/admin/tax-rates/".concat(s, "/product-types/batch?").concat(a);
        }
        return this.client.request("POST", n, e, {}, r);
      }
    }, {
      key: "addShippingOptions",
      value: function addShippingOptions(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/tax-rates/".concat(s, "/shipping-options/batch");
        if (t) {
          var a = m.stringify(t);
          n = "/admin/tax-rates/".concat(s, "/shipping-options/batch?").concat(a);
        }
        return this.client.request("POST", n, e, {}, r);
      }
    }, {
      key: "removeProducts",
      value: function removeProducts(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/tax-rates/".concat(s, "/products/batch");
        if (t) {
          var a = m.stringify(t);
          n = "/admin/tax-rates/".concat(s, "/products/batch?").concat(a);
        }
        return this.client.request("DELETE", n, e, {}, r);
      }
    }, {
      key: "removeProductTypes",
      value: function removeProductTypes(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/tax-rates/".concat(s, "/product-types/batch");
        if (t) {
          var a = m.stringify(t);
          n = "/admin/tax-rates/".concat(s, "/product-types/batch?").concat(a);
        }
        return this.client.request("DELETE", n, e, {}, r);
      }
    }, {
      key: "removeShippingOptions",
      value: function removeShippingOptions(s, e, t) {
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var n = "/admin/tax-rates/".concat(s, "/shipping-options/batch");
        if (t) {
          var a = m.stringify(t);
          n = "/admin/tax-rates/".concat(s, "/shipping-options/batch?").concat(a);
        }
        return this.client.request("DELETE", n, e, {}, r);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/tax-rates/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }]);
    return ze;
  }(i),
  vs = ze;
var He = /*#__PURE__*/function (_i54) {
    _inherits(He, _i54);
    var _super60 = _createSuper(He);
    function He() {
      var _this6;
      _classCallCheck(this, He);
      _this6 = _super60.apply(this, arguments);
      _this6.headers = {
        "Content-Type": "multipart/form-data"
      };
      return _this6;
    }
    _createClass(He, [{
      key: "create",
      value: function create(e) {
        var t = "/admin/uploads",
          r = this._createPayload(e);
        return this.client.request("POST", t, r, {}, this.headers);
      }
    }, {
      key: "createProtected",
      value: function createProtected(e) {
        var t = "/admin/uploads/protected",
          r = this._createPayload(e);
        return this.client.request("POST", t, r, {}, this.headers);
      }
    }, {
      key: "delete",
      value: function _delete(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/admin/uploads";
        return this.client.request("DELETE", r, e, {}, t);
      }
    }, {
      key: "getPresignedDownloadUrl",
      value: function getPresignedDownloadUrl(e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var r = "/admin/uploads/download-url";
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "_createPayload",
      value: function _createPayload(e) {
        var t = new FormData();
        return Array.isArray(e) ? e.forEach(function (r) {
          return t.append("files", r);
        }) : t.append("files", e), t;
      }
    }]);
    return He;
  }(i),
  Bs = He;
var je = /*#__PURE__*/function (_i55) {
    _inherits(je, _i55);
    var _super61 = _createSuper(je);
    function je() {
      _classCallCheck(this, je);
      return _super61.apply(this, arguments);
    }
    _createClass(je, [{
      key: "sendResetPasswordToken",
      value: function sendResetPasswordToken(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/users/password-token";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "resetPassword",
      value: function resetPassword(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "admin/users/reset-password";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "retrieve",
      value: function retrieve(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/users/".concat(s);
        return this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "create",
      value: function create(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/users";
        return this.client.request("POST", t, s, {}, e);
      }
    }, {
      key: "update",
      value: function update(s, e) {
        var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = "/admin/users/".concat(s);
        return this.client.request("POST", r, e, {}, t);
      }
    }, {
      key: "delete",
      value: function _delete(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/users/".concat(s);
        return this.client.request("DELETE", t, void 0, {}, e);
      }
    }, {
      key: "list",
      value: function list() {
        var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = "/admin/users";
        return this.client.request("GET", e, void 0, {}, s);
      }
    }]);
    return je;
  }(i),
  Is = je;
import ht from "qs";
var Je = /*#__PURE__*/function (_i56) {
    _inherits(Je, _i56);
    var _super62 = _createSuper(Je);
    function Je() {
      _classCallCheck(this, Je);
      return _super62.apply(this, arguments);
    }
    _createClass(Je, [{
      key: "list",
      value: function list(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/variants";
        return s && (t = "/admin/variants?".concat(ht.stringify(s))), this.client.request("GET", t, void 0, {}, e);
      }
    }, {
      key: "getInventory",
      value: function getInventory(s) {
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var t = "/admin/variants/".concat(s, "/inventory");
        return this.client.request("GET", t, void 0, {}, e);
      }
    }]);
    return Je;
  }(i),
  ks = Je;
var h = /*#__PURE__*/function (_i57) {
  _inherits(h, _i57);
  var _super63 = _createSuper(h);
  function h() {
    var _this7;
    _classCallCheck(this, h);
    _this7 = _super63.apply(this, arguments);
    _this7.auth = new Ye(_this7.client);
    _this7.batchJobs = new es(_this7.client);
    _this7.customers = new ns(_this7.client);
    _this7.customerGroups = new rs(_this7.client);
    _this7.discounts = new is(_this7.client);
    _this7.currencies = new ts(_this7.client);
    _this7.collections = new ss(_this7.client);
    _this7.draftOrders = new os(_this7.client);
    _this7.giftCards = new as(_this7.client);
    _this7.invites = new ds(_this7.client);
    _this7.notes = new ms(_this7.client);
    _this7.priceLists = new fs(_this7.client);
    _this7.products = new Cs(_this7.client);
    _this7.productTags = new qs(_this7.client);
    _this7.productTypes = new Ss(_this7.client);
    _this7.users = new Is(_this7.client);
    _this7.returns = new Es(_this7.client);
    _this7.orders = new ls(_this7.client);
    _this7.orderEdits = new ps(_this7.client);
    _this7.publishableApiKeys = new Ts(_this7.client);
    _this7.returnReasons = new $s(_this7.client);
    _this7.variants = new ks(_this7.client);
    _this7.salesChannels = new xs(_this7.client);
    _this7.swaps = new ws(_this7.client);
    _this7.shippingProfiles = new Ds(_this7.client);
    _this7.stockLocations = new Ls(_this7.client);
    _this7.store = new bs(_this7.client);
    _this7.shippingOptions = new Gs(_this7.client);
    _this7.regions = new Os(_this7.client);
    _this7.notifications = new cs(_this7.client);
    _this7.taxRates = new vs(_this7.client);
    _this7.uploads = new Bs(_this7.client);
    _this7.paymentCollections = new Ps(_this7.client);
    _this7.payments = new hs(_this7.client);
    _this7.productCategories = new ys(_this7.client);
    return _this7;
  }
  return _createClass(h);
}(i);
var _e = /*#__PURE__*/function () {
    function _e(s) {
      _classCallCheck(this, _e);
      this.client = new T(s), this.admin = new h(this.client), this.auth = new x(this.client), this.carts = new b(this.client), this.customers = new k(this.client), this.errors = new d(), this.orders = new M(this.client), this.orderEdits = new V(this.client), this.products = new ee(this.client), this.productTypes = new X(this.client), this.regions = new te(this.client), this.returnReasons = new ne(this.client), this.returns = new oe(this.client), this.shippingOptions = new de(this.client), this.swaps = new ce(this.client), this.collections = new v(this.client), this.giftCards = new K(this.client), this.paymentMethods = new R(this.client), this.paymentCollections = new H(this.client), this.productTags = new Q(this.client), this.productCategories = new J(this.client);
    }
    _createClass(_e, [{
      key: "setPublishableKey",
      value: function setPublishableKey(s) {
        p.registerPublishableApiKey(s);
      }
    }]);
    return _e;
  }(),
  vo = _e;
export { $ as AddressesResource, h as Admin, Ye as AdminAuthResource, es as AdminBatchJobsResource, ss as AdminCollectionsResource, ts as AdminCurrenciesResource, rs as AdminCustomerGroupsResource, ns as AdminCustomersResource, is as AdminDiscountsResource, os as AdminDraftOrdersResource, as as AdminGiftCardsResource, ds as AdminInvitesResource, ms as AdminNotesResource, cs as AdminNotificationsResource, ps as AdminOrderEditsResource, ls as AdminOrdersResource, Ps as AdminPaymentCollectionsResource, hs as AdminPaymentsResource, fs as AdminPriceListResource, ys as AdminProductCategoriesResource, qs as AdminProductTagsResource, Ss as AdminProductTypesResource, Cs as AdminProductsResource, Ts as AdminPublishableApiKeyResource, Os as AdminRegionsResource, $s as AdminReturnReasonsResource, Es as AdminReturnsResource, xs as AdminSalesChannelsResource, Gs as AdminShippingOptionsResource, Ds as AdminShippingProfilesResource, Ls as AdminStockLocationsResource, bs as AdminStoresResource, ws as AdminSwapsResource, vs as AdminTaxRatesResource, Bs as AdminUploadsResource, Is as AdminUsersResource, ks as AdminVariantsResource, x as AuthResource, i as BaseResource, b as CartsResource, T as Client, v as CollectionsResource, k as CustomersResource, K as GiftCardsResource, p as KeyManager, D as LineItemsResource, d as MedusaError, V as OrderEditsResource, M as OrdersResource, H as PaymentCollectionsResource, R as PaymentMethodsResource, J as ProductCategoriesResource, Q as ProductTagsResource, X as ProductTypesResource, ee as ProductsResource, te as RegionsResource, ne as ReturnReasonsResource, oe as ReturnsResource, de as ShippingOptionsResource, ce as SwapsResource, vo as default };